import React, { createContext, useContext, useState } from 'react';

const SearchTwoLayerContext = createContext();

export const useS2Layer = () => useContext(SearchTwoLayerContext);

export const SearchTwoLayerProvider = ({ children }) => {
    const [savedTransArray, setSavedTransArray] = useState({});
    const [savedEventArray, setSavedEventArray] = useState({});
    const [savedScoutSearchArray, setSavedScoutSearchArray] = useState({});

    // Custom update functions for each state
    const updateSavedTransArray = (newArray) => {
        setSavedTransArray(newArray);
    };

    const updateSavedEventArray = (newArray) => {
        setSavedEventArray(newArray);
    };

    const updateSavedScoutSearchArray = (newArray) => {
        setSavedScoutSearchArray(newArray);
    };

    return (
        <SearchTwoLayerContext.Provider
            value={{
                savedTransArray,
                updateSavedTransArray,
                savedEventArray,
                updateSavedEventArray,
                savedScoutSearchArray,
                updateSavedScoutSearchArray,
            }}
        >
            {children}
        </SearchTwoLayerContext.Provider>
    );
};
